import axios, { AxiosResponse, Method } from 'axios';
import accessToken from './accessToken';
import { readWebsiteVariable } from './readWebsiteVariable';
const axiosConfig = async (
  method: string,
  url: string,
  data?: unknown,
  callBack?: (r: unknown) => unknown,
  errorBack?: (e: unknown) => unknown
): Promise<void> => {
  const token = await accessToken();
  const inn = {
    baseURL: `https://${readWebsiteVariable('REACT_APP_api_domain')}/`,
    headers: {
      accept: 'application/json',
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  };

  const axiosInstance = axios.create(inn);

  if (method === 'get') {
    // eslint-disable-next-line
    return axiosInstance({ url: url, method: method })
      .then((response: unknown) => {
        if (callBack) callBack(response);
      })
      .catch((response: unknown) => {
        if (errorBack) errorBack(response);
      });
  } else if (method === 'post') {
    return axiosInstance({
      url: url,
      method: method,
      data: data
      // eslint-disable-next-line
    })
      .then((response: unknown) => {
        if (callBack) callBack(response);
      })
      .catch((response: unknown) => {
        if (errorBack) errorBack(response);
      });
  } else if (method === 'patch') {
    return axiosInstance({
      url: url,
      method: method,
      data: data
    })
      .then((response: unknown) => {
        if (callBack) callBack(response);
      })
      .catch((response: unknown) => {
        if (errorBack) errorBack(response);
      });
  } else if (method === 'delete') {
    return axiosInstance({
      url: url,
      method: method,
      data: data
    })
      .then((response: unknown) => {
        if (callBack) callBack(response);
      })
      .catch((response: unknown) => {
        if (errorBack) errorBack(response);
      });
  }
};

export const api = async (
  method: Method,
  uri: string,
  data?: unknown
): Promise<AxiosResponse<unknown>> => {
  const token = await accessToken();
  return axios({
    baseURL: `https://${readWebsiteVariable('REACT_APP_api_domain')}/`,
    headers: {
      accept: 'application/json',
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    },
    url: uri,
    method,
    data
  });
};

export default axiosConfig;
